import InfoIcon from '@mui/icons-material/Info';
import {
  Box,
  Breadcrumbs,
  Grid,
  InputAdornment,
  Tooltip,
  Typography,
} from '@mui/material';
import * as React from 'react';
import {
  Create,
  email,
  Form,
  minLength,
  PasswordInput,
  required,
  SaveButton,
  TextInput,
  useTranslate,
} from 'react-admin';
import { Link } from 'react-router-dom';
import AvatarInput from '../../components/AvatarInput';

export const validatePasswords = ({ password, password_confirmation }) => {
  const errors = {};

  if (password && password !== password_confirmation) {
    errors.password_confirmation = [
      'resources.members.errors.password_mismatch',
    ];
  }

  return errors;
};

export const MembersCreate = props => {
  const t = useTranslate();

  return (
    <Box pt={2}>
      <Breadcrumbs aria-label="breadcrumb">
        <Typography
          color="inherit"
          sx={{ fontSize: '14px', fontWeight: '400', lineHeight: '19px' }}
          component={Link}
          to="/teams"
        >
          Equipo
        </Typography>
        <Typography
          color="textPrimary"
          sx={{ fontSize: '14px', fontWeight: '600', lineHeight: '19px' }}
        >
          Crear Miembro
        </Typography>
      </Breadcrumbs>
      <Box maxWidth={{ xs: '100%', sm: 850 }} mt={{ xs: 2 }} mx="auto">
        <Typography color="textPrimary" variant="h5" sx={{ mb: 2 }}>
          Crear Miembro
        </Typography>
        <Create
          {...props}
          redirect="/teams"
          title={' '}
          sx={{ '& .RaCreate-card': { p: 2 } }}
        >
          <Form validate={validatePasswords}>
            <Box width={{ xs: '100%!important', md: '60%!important' }}>
              <Box display={{ xs: 'block', sm: 'flex' }}>
                <Box flex={1} style={{ alignSelf: 'center' }}>
                  <AvatarInput resource="members" source="avatar" fullWidth />
                </Box>
              </Box>
              <Box display={{ xs: 'block', sm: 'flex' }}>
                <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
                  <TextInput
                    source="first_name"
                    label="Nombre"
                    validate={requiredValidate}
                    fullWidth
                  />
                </Box>
                <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                  <TextInput
                    source="last_name"
                    label="Apellido"
                    validate={requiredValidate}
                    fullWidth
                  />
                </Box>
              </Box>
              <Box flex={1}>
                <TextInput
                  type="email"
                  source="email"
                  resource="members"
                  validate={[email(), required()]}
                  sx={{ width: '100%', maxWidth: '300px' }}
                />
              </Box>
              {/* <Box mt="0.5em" />
              <Box flex={1}>
                <ReferenceInput source="roles" reference="roles">
                  <SelectInput
                    label="Rol"
                    optionText="name"
                    validate={requiredValidate}
                  />
                </ReferenceInput>
              </Box>
              <Box mt="0.5em" /> */}
              <Box flex={1} style={{ display: 'flex', gap: '0.5em' }}>
                <TextInput
                  source="external_id"
                  resource="members"
                  label="external_id"
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tooltip
                          title={t('resources.members.create.tooltip')}
                          arrow
                        >
                          <InfoIcon
                            fontSize="small"
                            sx={{ color: '#737373' }}
                          />
                        </Tooltip>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box mt="1em" />
              <Box display={{ xs: 'block', sm: 'flex' }}>
                <Box flex={1} mr={{ xs: 0, sm: '0.5em' }}>
                  <PasswordInput
                    source="password"
                    resource="members"
                    fullWidth
                    validate={minLength(6)}
                    label="Contraseña"
                  />
                </Box>
                <Box flex={1} ml={{ xs: 0, sm: '0.5em' }}>
                  <PasswordInput
                    label="Confirmar contraseña"
                    source="password_confirmation"
                    resource="members"
                    validate={minLength(6)}
                    fullWidth
                  />
                </Box>
              </Box>
            </Box>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="flex-end"
            >
              <SaveButton
                sx={{
                  backgroundColor: '#3F49DB',
                  borderRadius: '500px !important',
                  textTransform: 'none !important',
                  fontSize: '14px !important',
                  lineHeight: '19px !important',
                  fontWeight: '600 !important',
                  letterSpacing: '0.5px !important',
                  padding: '8px 32px!important',
                  boxShadow: 'none !important',
                  svg: {
                    display: 'none',
                  },
                }}
              />
            </Grid>
          </Form>
        </Create>
      </Box>
    </Box>
  );
};

const requiredValidate = [required()];
